import {
  RECOVERY_OTP_COPY_BUTTON,
  RECOVERY_OTP_DOWNLOAD_BUTTON,
  RECOVERY_OTP_PRINT_BUTTON,
  RECOVERY_OTP_PRINT_TITLE,
  RECOVERY_OTP_TEXT_FILE_NAME,
  RECOVERY_OTP_TEXT_FILE_TITLE,
} from '../../constants/ui.labels'
import RecoveryOTPList from '../RecoveryOTPList'
import Box from '@talkdesk/cobalt-react-box'
import { Heading } from '@talkdesk/cobalt-react-typography'
import Button from '@talkdesk/cobalt-react-button'
import Flex from '@talkdesk/cobalt-react-flex'
import Card from '@talkdesk/cobalt-react-card'
import Divider from '@talkdesk/cobalt-react-divider'

const buildOTPList = (otpList, fileTitle) =>
  fileTitle.concat(otpList.join('\n'))

const downloadCodes = (otpList, fileTitle, fileName) => {
  const file = new Blob([buildOTPList(otpList, fileTitle)], {
    type: 'text/plain',
  })

  const element = document.createElement('a')
  element.href = URL.createObjectURL(file)
  element.download = fileName
  element.click()
}

const copyCodes = (otpList, fileTitle) => {
  if (!navigator.clipboard?.writeText) return
  navigator.clipboard
    .writeText(buildOTPList(otpList, fileTitle))
    .catch(() => {})
}

const RecoveryOTPBox = ({
  otpList,
  fileTitle = RECOVERY_OTP_TEXT_FILE_TITLE,
  fileName = RECOVERY_OTP_TEXT_FILE_NAME,
}) => {
  return (
    <Box width='100%'>
      <Flex direction='column' alignX='center' alignY='center'>
        <Heading level='2' className='print-only'>
          {RECOVERY_OTP_PRINT_TITLE}
        </Heading>
        <Card outlined>
          <Flex direction='column' alignX='center' alignY='center'>
            <RecoveryOTPList otpList={otpList} />
            <Divider />
            <Flex
              direction='row'
              grow
              gap='1'
              paddingX='5'
              paddingY='3'
              alignX='space-around'
              width='100%'
            >
              <Button
                htmlType='button'
                size='small'
                type='secondary'
                shape='full-width'
                onClick={() => downloadCodes(otpList, fileTitle, fileName)}
              >
                {RECOVERY_OTP_DOWNLOAD_BUTTON}
              </Button>
              <Button
                htmlType='button'
                size='small'
                type='secondary'
                shape='full-width'
                onClick={window.print}
              >
                {RECOVERY_OTP_PRINT_BUTTON}
              </Button>
              <Button
                htmlType='button'
                size='small'
                type='secondary'
                shape='full-width'
                onClick={() => copyCodes(otpList, fileTitle)}
              >
                {RECOVERY_OTP_COPY_BUTTON}
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </Box>
  )
}

export default RecoveryOTPBox
